import { z } from "zod";

export const ShapeKindSchema = z.enum([
  "ellipse",
  "rounded-rect",
  "diamond",
  "hexagon",
  "parallelogram",
  "circle",
]);
export type ShapeKind = z.infer<typeof ShapeKindSchema>;

/** Optionales BPMN-Semantik-Tag. Wird in Welle 3 (swimlane) fuer Auto-Routing /
 *  Connector-Defaults genutzt. V1 ist es rein deklarativ — Renderer schaut nicht drauf. */
export const ShapeSemanticsSchema = z.enum([
  "bpmn:start",
  "bpmn:end",
  "bpmn:task",
  "bpmn:gateway",
  "bpmn:subprocess",
  "bpmn:data",
]);
export type ShapeSemantics = z.infer<typeof ShapeSemanticsSchema>;
